import VueCharts from "vue-chartjs";
import { HorizontalBar } from "vue-chartjs";

export default {
    extends: HorizontalBar,
    props: ['data', 'options'],
    mounted() {
        this.renderChart(this.data, this.options);
    },
    watch: {
        data: {
            handler(newVal, oldVal) {
                this.renderChart(this.data, this.options);
            },
            deep: true
        }
    }
};
